import React from "react";
import { FinanceProvider } from "./components/FinanceAccess";
import { ConfigProvider } from "antd";
import { useUser } from "./context/UserContext";
import AppRouter from "./routes/AppRouter";
import "./App.css";
import "antd/dist/reset.css";
import "./studio.css";
import "./events.css";
import "./Layout/workspace.css";
import "./theme/application.css";
import "./theme/forms.css";
import { workspaceTheme } from "./theme/workspaceTheme";

function App() {
  const { user, loading } = useUser();

  return (
    <ConfigProvider
      theme={workspaceTheme}
    >
      <FinanceProvider key={user?.id || "guest"}><AppRouter userData={user} loading={loading} /></FinanceProvider>
    </ConfigProvider>
  );
}

export default App;
